import { bootstrap as bootstrapDevelopmentLogging } from './development-logging';
import { bootstrap as bootstrapAuth } from './auth';
import { bootstrap as bootstrapUserRoles } from './user-roles';

bootstrapDevelopmentLogging();
bootstrapAuth();
bootstrapUserRoles();
